import { ScrollContainer } from '@codezo/ui';
import { UserManagementTable } from '../components/UserManagementTable';

export function UsersPage() {
	return (
		<ScrollContainer>
			<UserManagementTable />
		</ScrollContainer>
	);
}
